import React from 'react'
import styled from 'styled-components'

export default ({ text, icon, className }) => (
  <Wrapper className={className}>
    <Icon src={icon} alt={text} />
    <Text>{text}</Text>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  max-width: 300px;
  text-align: left;
  align-items: center;
`

const Icon = styled.img`
  height: 20px;

  width: 20px;
`

const Text = styled.span`
  display: inline-block;
  vertical-align: middle;
  color: #676767;
  font-size: 12px;
  font-weight: 300;
  line-height: 12px;
  margin-left: 10px;
`



// WEBPACK FOOTER //
// ./src/components/Toltip/index.js